import React from 'react'
import { Link } from 'gatsby'
import Hero from '../components/Hero'
import styled from 'styled-components'
import Error404 from '../assets/404-error.png'
import SnowCamp from '../assets/snow-camp.png'
import ScribeAgency from '../assets/scribe-agency.png'
import SignUpForm from '../assets/sign-up-form.png'
import SignUpGym from '../assets/sign-up-gym.png'
import SoundJam from '../assets/sound-jam.png'
import SignUp from '../assets/sign-up.png'
import QuoteMachine from '../assets/Juxtapose-Quote-Machine.png'
import gh from 'parse-github-url'
import { motion } from 'framer-motion'

const BooksPage = props => {
  const githubRepo = gh('https://www.github.com/robgmerrill')
  return (
    <Wrapper>
      <Hero />
      <div className="solutions-container">
        {props.data.allGoogleFrontendPlaygroundSheet.edges.map(edge => (
          <div key={edge.node.id} className="solution-container">
            <SolutionImageWrapper>
              {edge.node.projectTitle === '404-error' && <img src={Error404} />}
              {edge.node.projectTitle === 'sound-jam' && <img src={SoundJam} />}
              {edge.node.projectTitle === 'sign-up' && <img src={SignUp} />}
              {edge.node.projectTitle === 'scribe-agency' && (
                <img src={ScribeAgency} />
              )}
              {edge.node.projectTitle === 'snow-camp' && <img src={SnowCamp} />}
              {edge.node.projectTitle === 'quote-machine' && (
                <img src={QuoteMachine} />
              )}
              {edge.node.projectTitle === 'sign-up-form' && (
                <img src={SignUpForm} />
              )}
              {edge.node.projectTitle === 'sign-up-gym' && (
                <img src={SignUpGym} />
              )}
            </SolutionImageWrapper>
            <div>{edge.node.repository.png}</div>
            <div className="text-button-container">
              {edge.node.projectTitle === 'snow-camp' && <h2>Snow Camp</h2>}
              {edge.node.projectTitle === 'quote-machine' && (
                <h2>Quote Machine</h2>
              )}
              {edge.node.projectTitle === 'sign-up-form' && (
                <h2>Sign Up Form</h2>
              )}
              {edge.node.projectTitle === 'sign-up' && <h2>Simple Sign Up</h2>}
              {edge.node.projectTitle === 'double-grid-component' && (
                <h2>Double Grid Component</h2>
              )}
              {edge.node.projectTitle === 'sign-up-gym' && <h2>Gym Sign Up</h2>}
              {edge.node.projectTitle === '404-error' && <h2>404 Error</h2>}
              {edge.node.projectTitle === 'scribe-agency' && (
                <h2>Scribe Agency</h2>
              )}
              {Object.keys(gh(edge.node.repository)).map(function (key) {
                if (key === 'owner') {
                  const person = gh(edge.node.repository)[key]
                  const avatarImageLink = `https://www.github.com/${person}.png?size=200`
                  return (
                    <div>
                      <div>
                        GitHub Username: {gh(edge.node.repository)[key]}
                      </div>
                      <img className="avatar-image" src={avatarImageLink} />
                    </div>
                  )
                }
              })}

              <div>{edge.node.repository.png}</div>
              {/* <div>Submitted: {edge.node.date}</div> */}
              <div>
                <Link to={`/solution/${edge.node.id} `}>
                  <div className="link-button">
                    <motion.button
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      className="btn btn-solutions"
                    >
                      Solution Details
                    </motion.button>
                  </div>
                </Link>
                {/* <div className="underline"></div> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  /* background: #e5e2fd; */
  .text-button-container {
    padding: 0 12px 20px;
  }
  .avatar-image {
    border-radius: 50%;
    height: 50px;
    width: 50px;
  }
  .underline {
    margin-top: 12px;
    width: 100%;
    height: 5px;
    background: var(--clr-primary-5);
  }
  .text-button-container h2 {
    font-size: 24px;
  }
  .solutions-container {
    display: grid;
    padding: 20px;
    /* grid-template-columns: 1fr 1fr 1fr; */
    grid-gap: 20px;
  }
  .solution-container {
    /* background: #f8f8f8; */
    /* border: 1px solid #f8f8f8; */
    border-radius: 10px;
    /* padding: 20px; */
  }
  .link-button {
    margin-top: 15px;
    display: grid;
    place-items: center;
  }
  .btn-solutions {
    width: 90%;
    border-radius: 22px;
  }
  @media (min-width: 768px) {
    .solutions-container {
      width: 98%;
      display: grid;
      grid-template-columns: 33% 33% 33%;
      /* grid-gap: 20px; */
      padding: 0 25px;
    }
    .solution-container {
      /* border: 1px solid #f8f8f8; */
      border-radius: 10px;
      /* padding: 20px; */
    }
    .link-button {
      display: grid;
      place-items: center;
    }
    .btn-solutions {
      width: 90%;
      border-radius: 22px;
    }
  }
`

const SolutionImageWrapper = styled.div`
  /* display: none; */
  /* width: 30%; */
  /* overflow: hidden; */
  /* max-height: 250px; */
  width: 100%;
  img {
    /* display: none; */
    /* transform: scale(0.5); */
    height: 250px;
    width: 100%;
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  }
`

export const query = graphql`
  query MyQuery {
    allGoogleFrontendPlaygroundSheet(sort: { fields: date, order: DESC }) {
      edges {
        node {
          id
          livesite
          projectTitle
          solutiontitle
          repository
          feedback
          projectTitle
          date
        }
      }
    }
  }
`

export default BooksPage
